import { AssertIsStringException } from './assert-is-string.exception';
import { isString } from '@camino-solutions/utils/typeguard';

export function assertIsString(value: unknown): asserts value is string {
  if (!isString(value)) {
    throw new AssertIsStringException(`Not a string: ${value}`);
  }
}
